import React, { useState } from 'react';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { NGANH_API } from '@app/utils/apiUrl';
import { Post } from '@app/utils/httpProvider';
import { messageError, messageToast, status200 } from '../../../../utils/define';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import { Button } from '@components';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';
import Editor from '@app/components/editor/Editor';

const schema = yup.object().shape({
    maNganh: yup.string().required(messageError.emptyMessage).max(50, 'Mã ngành không được vượt quá 50 ký tự'),
    maChuyenNganh: yup.string().nullable().max(50, 'Mã chuyên ngành không được vượt quá 50 ký tự'),
    tenNganh: yup.string().required(messageError.emptyMessage).max(255, 'Tên ngành không được vượt quá 255 ký tự')
});

const NganhAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const addFunc = useMutation((value) =>
        Post(NGANH_API.ADD_ITEM, null, value, false)
    );

    const handleCreate = async (values) => {
        const model = values;

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    setIsLoading(true);
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm mới ngành</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        maNganh: '',
                        maChuyenNganh: '',
                        tenNganh: '',
                        moTa: ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Mã ngành',
                                        name: 'maNganh',
                                        value: values.maNganh,
                                        onChange: handleChange,
                                        isInvalid: errors.maNganh,
                                        error: errors.maNganh
                                    },
                                    {
                                        label: 'Mã chuyên ngành',
                                        name: 'maChuyenNganh',
                                        value: values.maChuyenNganh,
                                        onChange: handleChange,
                                        isInvalid: errors.maChuyenNganh,
                                        error: errors.maChuyenNganh
                                    },
                                ]}
                            />
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Tên ngành',
                                        name: 'tenNganh',
                                        value: values.tenNganh,
                                        onChange: handleChange,
                                        isInvalid: errors.tenNganh,
                                        error: errors.tenNganh
                                    },
                                ]}
                            />
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Mô tả
                                </Form.Label>
                                <Col sm="10">
                                    <Col sm="10">
                                        <Editor
                                            name="moTa"
                                            value={values.moTa}
                                            onChange={(value) => {
                                                setFieldValue(
                                                    'moTa',
                                                    value
                                                );
                                            }}
                                        />
                                    </Col>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button type="submit" theme="primary" disabled={isLoading}>
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button onClick={() => history.push(URI_INTERNAL.NGANH_PATH)} theme="secondary">
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
                {isLoading && <div>Đang lưu...</div>}
            </Card.Body>
        </Card>
    );
};

export default NganhAdd;
